export default [
  {
    path: 'compras',
    name: 'empresa.comprasHome',
    component: () => import('@/views/empresa/compras/ComprasEmpresaLayout.vue'),
    
    children: [
      // Dashboard o vista general de compras
      {
        path: '',
        name: 'empresa.comprasListado',
        component: () => import('@/views/empresa/compras/ComprasEmpresaListado.vue'),
      },
     

      // 📦 Pedidos
      {
        path: 'pedido',
        name: 'empresa.comprasPedidoListado',
        component: () => import('@/views/empresa/compras/pedido/CompraPedidoEmpresaHome.vue'),
      },
      {
        path: 'pedido/registrar',
        name: 'empresa.comprasPedidoRegistrar',
        component: () => import('@/views/empresa/compras/pedido/CompraPedidoEmpresaRegistrar.vue'),
      },
      {
        path: 'pedido/:id',
        name: 'empresa.comprasPedidoConsultar',
        component: () => import('@/views/empresa/compras/pedido/CompraPedidoEmpresaConsultar.vue'),
      },
      {
        path: 'pedido/:id/editar',
        name: 'empresa.comprasPedidoEditar',
        component: () => import('@/views/empresa/compras/pedido/CompraPedidoEmpresaEditar.vue'),
      },


      // 🧾 Facturas
      {
        path: 'factura',
        name: 'empresa.comprasFacturaListado',
        component: () => import('@/views/empresa/compras/factura/CompraFacturaEmpresaHome.vue'),
      },
      {
        path: 'factura/registrar',
        name: 'empresa.comprasFacturaRegistrar',
        component: () => import('@/components/shared/compras/factura/CompraFacturaEmpresaRegistrar.vue'),
      },
      {
        path: 'factura/:uuid_factura',
        name: 'empresa.comprasFacturaConsultar',
        component: () => import('@/components/shared/compras/factura/CompraFacturaEmpresaConsultar.vue'),
      },
      {
        path: 'factura/:uuid_factura/editar',
        name: 'empresa.comprasFacturaEditar',
        component: () => import('@/components/shared/compras/factura/CompraFacturaEmpresaEditar.vue'),
      },

      // 📄 Remitos
      {
        path: 'remito',
        name: 'empresa.comprasRemitoListado',
        component: () => import('@/views/empresa/compras/remito/CompraRemitoEmpresaHome.vue'),
      },
      {
        path: 'remito/registrar',
        name: 'empresa.comprasRemitoRegistrar',
        component: () => import('@/views/empresa/compras/remito/CompraRemitoEmpresaRegistrar.vue'),
      },
      {
        path: 'remito/:uuid_remito',
        name: 'empresa.comprasRemitoConsultar',
        component: () => import('@/views/empresa/compras/remito/CompraRemitoEmpresaConsultar.vue'),
      },
      {
        path: 'remito/:uuid_remito/editar',
        name: 'empresa.comprasRemitoEditar',
        component: () => import('@/views/empresa/compras/remito/CompraRemitoEmpresaEditar.vue'),
      },
    ],
  },
]
